import { CommonModule } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { AsideComponent } from './aside/aside.component';
import { HaederComponent } from './haeder/haeder.component';
import { StartupPprofileHaederComponent } from './startup-profile-haeder/startup-profile-haeder.component';

@Component({
  selector: 'app-founder-panel-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    ToastModule,
    AsideComponent,
    HaederComponent,
    StartupPprofileHaederComponent
  ],
  templateUrl: './founder-panel-layout.component.html',
  styleUrl: './founder-panel-layout.component.scss'
})
export class FounderPanelLayoutComponent implements OnInit {
  sidebarOpen: boolean = true;

  constructor(
  ) { }

  ngOnInit(): void {
    this.checkScreenWidth();


  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenWidth();
  }

  checkScreenWidth() {
    this.sidebarOpen = window.innerWidth > 991;
  }

  toggleSidebar() {
    this.sidebarOpen = !this.sidebarOpen;
  }

}
